import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=34072058&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDialog.vue?vue&type=style&index=0&id=34072058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34072058",
  null
  
)

export default component.exports